import PropTypes from 'prop-types'
import CommodityClass from './commodity_class'

export default PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  code: PropTypes.string.isRequired,
  item_description: PropTypes.string.isRequired,
  hierarchy: PropTypes.string.isRequired,
  commodities: PropTypes.arrayOf(CommodityClass),
  all_classes_selected: PropTypes.bool
})
